"use client";

import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from "react";
import { ApiWaveType } from "@/generated/models/ApiWaveType";
import type { ApiWave } from "@/generated/models/ApiWave";
import WaveApprovalThresholds from "@/components/waves/specs/WaveApprovalThresholds";
import WaveApproveTabLabels from "@/components/waves/specs/WaveApproveTabLabels";
import WaveDisableLinks from "@/components/waves/specs/WaveDisableLinks";
import WaveGroup from "@/components/waves/specs/groups/group/WaveGroup";
import { WaveGroupType } from "@/components/waves/specs/groups/group/WaveGroup.types";
import WaveSlowMode from "@/components/waves/specs/WaveSlowMode";
import WaveActiveCurationSection from "./curation/WaveActiveCurationSection";
interface WaveSettingsSectionsProps {
  readonly wave: ApiWave;
}
const SettingsSection = t0 => {
  const $ = _c(7);
  const {
    children,
    title
  } = t0;
  let t1;
  if ($[0] !== title) {
    t1 = <div className="tw-flex tw-items-start tw-justify-between tw-gap-x-6 tw-px-4 tw-pt-6"><p className="tw-mb-0 tw-text-xs tw-font-semibold tw-uppercase tw-tracking-wider tw-text-iron-300">{title}</p></div>;
    $[0] = title;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== children) {
    t2 = <div className="tw-mt-2 tw-flex tw-flex-col tw-gap-y-0.5 tw-px-2">{children}</div>;
    $[2] = children;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = <section>{t1}{t2}</section>;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
};
export default function WaveSettingsSections(t0) {
  const $ = _c(24);
  const {
    wave
  } = t0;
  const isApproveWave = wave.wave.type === ApiWaveType.Approve;
  const showChatSettings = wave.chat.enabled;
  let t1;
  if ($[0] !== wave) {
    t1 = <WaveActiveCurationSection wave={wave} />;
    $[0] = wave;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== isApproveWave || $[3] !== wave) {
    t2 = isApproveWave && <><SettingsSection title="Approval tabs"><WaveApproveTabLabels wave={wave} /></SettingsSection><SettingsSection title="Approval rule"><WaveApprovalThresholds wave={wave} /></SettingsSection></>;
    $[2] = isApproveWave;
    $[3] = wave;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== showChatSettings || $[6] !== wave) {
    t3 = showChatSettings && <SettingsSection title="Chat"><WaveSlowMode wave={wave} /><WaveDisableLinks wave={wave} /></SettingsSection>;
    $[5] = showChatSettings;
    $[6] = wave;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  let t5;
  if ($[8] !== wave) {
    t4 = <WaveGroup scope={wave.visibility.scope} type={WaveGroupType.VIEW} wave={wave} />;
    t5 = wave.wave.type !== ApiWaveType.Chat && <><WaveGroup scope={wave.participation.scope} type={WaveGroupType.DROP} wave={wave} /><WaveGroup scope={wave.voting.scope} type={WaveGroupType.VOTE} wave={wave} /></>;
    $[8] = wave;
    $[9] = t4;
    $[10] = t5;
  } else {
    t4 = $[9];
    t5 = $[10];
  }
  let t6;
  let t7;
  if ($[11] !== wave) {
    t6 = <WaveGroup scope={wave.chat.scope} type={WaveGroupType.CHAT} wave={wave} />;
    t7 = <WaveGroup scope={wave.wave.admin_group} type={WaveGroupType.ADMIN} wave={wave} />;
    $[11] = wave;
    $[12] = t6;
    $[13] = t7;
  } else {
    t6 = $[12];
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t4 || $[15] !== t5 || $[16] !== t6 || $[17] !== t7) {
    t8 = <SettingsSection title="Access">{t4}{t5}{t6}{t7}</SettingsSection>;
    $[14] = t4;
    $[15] = t5;
    $[16] = t6;
    $[17] = t7;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== t1 || $[20] !== t2 || $[21] !== t3 || $[22] !== t8) {
    t9 = <div className="tw-pb-4">{t1}{t2}{t3}{t8}</div>;
    $[19] = t1;
    $[20] = t2;
    $[21] = t3;
    $[22] = t8;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  return t9;
}